var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.hall
    }
  }, [_vm._l(_vm.items, function (item) {
    var _item$program, _item$work, _item$work2, _item$work3, _item$work3$author, _item$work3$author$na, _item$work4, _item$work5, _item$work6, _item$work7, _item$work8, _item$work8$price_auc, _item$work8$price_auc2, _item$work8$price_auc3, _item$price, _item$price$format, _item$work9, _item$work9$price_auc, _item$work10, _item$work11, _item$work11$price_au, _item$work11$price_au2, _item$work11$price_au3, _item$createdAt, _item$createdAt$toDat, _item$work12, _item$work12$price_au, _item$work12$price_au2;

    return _c('div', {
      key: item._id,
      attrs: {
        "flat": ""
      }
    }, [item.showsProgram ? [_c('div', {
      staticClass: "mt-30 mb-6 mt-md-40 mb-md-10"
    }, [_c('h3', {
      staticClass: "tit tit--xs"
    }, [_vm._v(_vm._s((item === null || item === void 0 ? void 0 : (_item$program = item.program) === null || _item$program === void 0 ? void 0 : _item$program.subject) || "-"))])]), _c('v-divider', {
      staticClass: "primary"
    })] : _vm._e(), _c('div', {
      staticClass: "py-14"
    }, [_c('v-row', {
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "6",
        "align-self": "center"
      }
    }, [_c('v-row', {
      attrs: {
        "no-gutters": "",
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "4"
      }
    }, [_c('bids-item-imgs', {
      attrs: {
        "imgs": item === null || item === void 0 ? void 0 : (_item$work = item.work) === null || _item$work === void 0 ? void 0 : _item$work.imgs
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "8"
      }
    }, [_c('div', {
      staticClass: "pl-16 pl-md-20"
    }, [_c('div', {
      staticClass: "d-flex flex-wrap align-center"
    }, [_c('v-chip', {
      staticClass: "rounded-0 mr-8",
      attrs: {
        "outlined": "",
        "small": ""
      }
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$work2 = item.work) === null || _item$work2 === void 0 ? void 0 : _item$work2.lot))]), _c('strong', {
      staticClass: "font-size-16 font-size-md-18"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$work3 = item.work) === null || _item$work3 === void 0 ? void 0 : (_item$work3$author = _item$work3.author) === null || _item$work3$author === void 0 ? void 0 : (_item$work3$author$na = _item$work3$author.name) === null || _item$work3$author$na === void 0 ? void 0 : _item$work3$author$na.ko))])], 1), _c('div', {
      staticClass: "mt-2 mt-md-4"
    }, [_c('span', {
      staticClass: "font-size-14 font-size-md-16"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$work4 = item.work) === null || _item$work4 === void 0 ? void 0 : _item$work4.subject))])]), _c('div', {
      staticClass: "mt-8 mt-md-10"
    }, [_c('div', {
      staticClass: "font-size-14 line-height-13 grey-68--text"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$work5 = item.work) === null || _item$work5 === void 0 ? void 0 : _item$work5.year)), _c('br'), _vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$work6 = item.work) === null || _item$work6 === void 0 ? void 0 : _item$work6.material) + " ㅣ " + _vm._s(item === null || item === void 0 ? void 0 : (_item$work7 = item.work) === null || _item$work7 === void 0 ? void 0 : _item$work7.dimensionTag))])])])])], 1)], 1), _c('v-col', {
      staticClass: "d-none d-md-block",
      staticStyle: {
        "margin-left": "-1px"
      },
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-divider', {
      staticClass: "grey-da",
      attrs: {
        "vertical": ""
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('div', {
      staticClass: "font-size-14 py-10 pa-md-20 pl-md-40"
    }, [_c('v-row', {
      attrs: {
        "no-gutters": "",
        "align": "baseline"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('span', [_vm._v("시작가")])]), _c('v-col', {
      attrs: {
        "cols": "9"
      }
    }, [_c('div', {
      staticClass: "grey-68--text pl-sm-12"
    }, [_vm._v("KRW " + _vm._s(item === null || item === void 0 ? void 0 : (_item$work8 = item.work) === null || _item$work8 === void 0 ? void 0 : (_item$work8$price_auc = _item$work8.price_auction) === null || _item$work8$price_auc === void 0 ? void 0 : (_item$work8$price_auc2 = _item$work8$price_auc.from) === null || _item$work8$price_auc2 === void 0 ? void 0 : (_item$work8$price_auc3 = _item$work8$price_auc2.format) === null || _item$work8$price_auc3 === void 0 ? void 0 : _item$work8$price_auc3.call(_item$work8$price_auc2)))])])], 1), _c('v-row', {
      staticClass: "font-weight-medium mt-2 mt-md-4",
      attrs: {
        "no-gutters": "",
        "align": "baseline"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('span', [_vm._v("응찰가")])]), _c('v-col', {
      attrs: {
        "cols": "9"
      }
    }, [_c('div', {
      staticClass: "pl-sm-12"
    }, [_vm._v(" KRW " + _vm._s(item === null || item === void 0 ? void 0 : (_item$price = item.price) === null || _item$price === void 0 ? void 0 : (_item$price$format = _item$price.format) === null || _item$price$format === void 0 ? void 0 : _item$price$format.call(_item$price)) + " "), (item === null || item === void 0 ? void 0 : item._id) == (item === null || item === void 0 ? void 0 : (_item$work9 = item.work) === null || _item$work9 === void 0 ? void 0 : (_item$work9$price_auc = _item$work9.price_auction) === null || _item$work9$price_auc === void 0 ? void 0 : _item$work9$price_auc._bid) ? _c('span', [_vm._v(" [" + _vm._s((item === null || item === void 0 ? void 0 : (_item$work10 = item.work) === null || _item$work10 === void 0 ? void 0 : _item$work10.isAuctionEnded) ? '낙찰' : '최고가') + "] ")]) : _vm._e()])])], 1), _c('v-row', {
      staticClass: "mt-2 mt-md-4",
      attrs: {
        "no-gutters": "",
        "align": "baseline"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('span', [_vm._v("낙찰가")])]), _c('v-col', {
      attrs: {
        "cols": "9"
      }
    }, [_c('div', {
      staticClass: "grey-68--text pl-sm-12"
    }, [_vm._v("KRW " + _vm._s(item === null || item === void 0 ? void 0 : (_item$work11 = item.work) === null || _item$work11 === void 0 ? void 0 : (_item$work11$price_au = _item$work11.price_auction) === null || _item$work11$price_au === void 0 ? void 0 : (_item$work11$price_au2 = _item$work11$price_au.current) === null || _item$work11$price_au2 === void 0 ? void 0 : (_item$work11$price_au3 = _item$work11$price_au2.format) === null || _item$work11$price_au3 === void 0 ? void 0 : _item$work11$price_au3.call(_item$work11$price_au2)))])])], 1), _c('v-row', {
      staticClass: "mt-2 mt-md-4",
      attrs: {
        "no-gutters": "",
        "align": "baseline"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('span', [_vm._v("응찰일자")])]), _c('v-col', {
      attrs: {
        "cols": "9"
      }
    }, [_c('div', {
      staticClass: "grey-68--text pl-sm-12"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$createdAt = item.createdAt) === null || _item$createdAt === void 0 ? void 0 : (_item$createdAt$toDat = _item$createdAt.toDateTime) === null || _item$createdAt$toDat === void 0 ? void 0 : _item$createdAt$toDat.call(_item$createdAt)))])])], 1)], 1)]), _c('v-col', {
      staticClass: "d-none d-md-block",
      staticStyle: {
        "margin-left": "-1px"
      },
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-divider', {
      staticClass: "grey-da",
      attrs: {
        "vertical": ""
      }
    })], 1), _c('v-col', {
      staticClass: "text-center",
      attrs: {
        "cols": "12",
        "md": "2",
        "align-self": "center"
      }
    }, [_vm.type == 'all' ? _c('auction-bids', {
      attrs: {
        "bids": item.work.bids
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var attrs = _ref.attrs,
              on = _ref.on;
          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "small": "",
              "color": "primary"
            }
          }, 'v-btn', attrs, false), on), [_vm._v("응찰기록")])];
        }
      }], null, true)
    }) : _vm._e(), _vm.type == 'won' ? _c('auction-won-notice', _vm._b({
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref2) {
          var attrs = _ref2.attrs,
              on = _ref2.on;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "px-md-6",
            attrs: {
              "small": "",
              "color": "primary"
            }
          }, 'v-btn', attrs, false), on), [_c('span', {
            staticClass: "font-size-14"
          }, [_vm._v("낙찰결과 통보서 보기")])])];
        }
      }], null, true)
    }, 'auction-won-notice', {
      program: item.program,
      bids: [item],
      user: _vm.user
    }, false)) : _vm._e()], 1)], 1)], 1), _c('v-divider', {
      staticClass: "grey-da"
    }), _vm.type == 'won' ? [_c('div', {
      staticClass: "pa-12 d-flex align-center justify-center grey-ef"
    }, [_c('span', {
      staticClass: "font-size-14 font-size-md-16 grey-68--text"
    }, [_vm._v(" 총 결제금액: "), _c('span', {
      staticClass: "font-weight-medium primary--text"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$work12 = item.work) === null || _item$work12 === void 0 ? void 0 : (_item$work12$price_au = _item$work12.price_auction.total) === null || _item$work12$price_au === void 0 ? void 0 : (_item$work12$price_au2 = _item$work12$price_au.format) === null || _item$work12$price_au2 === void 0 ? void 0 : _item$work12$price_au2.call(_item$work12$price_au)) + "원 + (배송비: " + _vm._s(_vm.delivery) + "원)")])])]), _c('v-divider', {
      staticClass: "grey-da"
    })] : _vm._e()], 2);
  }), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "absolute": "",
      "light": "",
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": "3",
      "color": "black"
    }
  })], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }